var _excluded = ["children", "className", "full"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** @component card */
import React from 'react';
import PropTypes from 'prop-types';

var CardSection = function CardSection(props) {
  var children = props.children,
      className = props.className,
      full = props.full,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "md-card-section" + ("" + (full && " md-card-section--full" || '')) + ("" + (className && " " + className || ''))
  }, otherProps), children);
};

CardSection.propTypes = {
  /** @prop Children nodes to render inside the CardSection | null */
  children: PropTypes.node,

  /** @prop Optional css class names | '' */
  className: PropTypes.string,

  /** @prop Set the card section to be the full width | false */
  full: PropTypes.bool
};
CardSection.defaultProps = {
  children: null,
  className: '',
  full: false
};
CardSection.displayName = 'CardSection';
export default CardSection;